import React from "react";
import { ReactComponent as IntegrationsIcon1 } from "../../assets/Feature/IntegrationsIcon1.svg";
import { ReactComponent as IntegrationsIcon4 } from "../../assets/Feature/IntegrationsIcon4.svg";
import { ReactComponent as IntegrationsIcon5 } from "../../assets/Feature/IntegrationsIcon5.svg";
import { lazySvg } from "../../utility/lazySvg";

// The big drawings load apart from the page code (see lazySvg).
const Integrations1 = lazySvg(() => import("../../assets/Feature/Integrations1.svg"), { width: "552", height: "369", viewBox: "0 0 552 369" });
const Integrations2 = lazySvg(() => import("../../assets/Feature/Integrations2.svg"), { width: "540", height: "240", viewBox: "0 0 540 240" });
const IntegrationsIcon2 = lazySvg(() => import("../../assets/Feature/IntegrationsIcon2.svg"), { width: "68", height: "68", viewBox: "0 0 68 68" });
const IntegrationsIcon3 = lazySvg(() => import("../../assets/Feature/IntegrationsIcon3.svg"), { width: "68", height: "68", viewBox: "0 0 68 68" });

const Integrations = () => {
  return (
    <div className="mt-5">
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Left Card */}
        <div className="bg-[#F46350] rounded-4xl md:p-8 py-4 px-8 flex flex-col xl:justify-between ">
          <div>
            <div className="flex justify-between lg:flex-row flex-col items-start mb-4">
              <h2 className="font-secondary text-white font-bold text-4xl mb-2 lg:w-1/2 w-full">
                Client Names <br className="xl:block hidden" /> in Orders
              </h2>
              <div className="border border-white text-white text-center uppercase rounded-full px-4 py-1 font-semibold whitespace-nowrap">
                For Business Accounts
              </div>
            </div>
            <p className="text-white text-base mb-4 lg:w-[70%] w-full">
              Easily add your client’s name to each order to organize and track
              translations by case or customer.
            </p>
          </div>
          <div className="mt-8 flex justify-center w-full">
            <Integrations1 className="max-w-fit max-h-fit" />
          </div>
        </div>

        {/* Right Card */}
        <div className="bg-[#7245ED] rounded-4xl md:p-8 py-4 px-8 flex flex-col xl:justify-between ">
          <div className="">
            <div className="flex justify-between lg:flex-row flex-col items-start mb-4">
              <h2 className="font-secondary text-white font-semibold text-4xl mb-2 lg:w-[55%] w-full">
                Chat within <br className="xl:block hidden" />
                an order
              </h2>
              <div className="border border-white text-white  text-center uppercase rounded-full px-4 py-1 font-semibold whitespace-nowrap">
                For All
              </div>
            </div>
            <p className="text-white text-base mb-4 lg:w-[62%] w-full">
              Skip the back-and-forths of emails—get fast replies directly in
              the order, usually within minutes.
            </p>
          </div>
          <div className="mt-8 flex justify-center w-full">
            <Integrations2 className="max-w-fit max-h-fit" />
          </div>
        </div>
      </div>

      <div className="mt-5 w-full bg-white shadow-md py-24 md:px-4 px-8 rounded-4xl overflow-hidden flex justify-center ">
        <div className="w-fit flex justify-center gap-4 flex-col items-center z-10 relative">
          <IntegrationsIcon1 className="absolute lg:-top-[10%] lg:-left-[15%] -top-1/3 left-0 h-16 w-16 -z-10" />
          <IntegrationsIcon2 className="absolute lg:top-1/3 lg:left-[10%] -top-1/3 right-0 h-16 w-16 -z-10" />
          <IntegrationsIcon3 className="lg:block hidden absolute top-3/4 -left-[30%] h-16 w-16 -z-10" />

          <h2 className="font-secondary font-medium md:text-4xl text-3xl text-tertiary">
            Integrations
          </h2>
          {/* The order API, its webhooks and the MCP server for AI assistants
              (8 Oct 2026) are live; this card still said "coming soon" for all
              of it. Only Clio is pending: its App Directory listing is in review. */}
          <p className="text-[#686F7B] text-base text-center xl:w-1/2 w-full">
            Order from the tools you already use. A REST API with webhooks lets
            your systems place and track orders, and AI assistants such as
            Claude and ChatGPT can quote, order and follow up through our MCP
            server, always showing the price before anything happens.
          </p>
          <ul className="text-[#686F7B] text-base text-left flex flex-col gap-1">
            <li><strong className="text-tertiary">REST API and webhooks</strong> — live</li>
            <li><strong className="text-tertiary">AI assistants (MCP)</strong> — live, with spending limits</li>
            <li><strong className="text-tertiary">Clio</strong> — coming soon</li>
          </ul>
          {/* A static page, not a React route: needs a full page load. */}
          <a href="/integrations" className="w-fit border border-tertiary text-tertiary rounded-full px-16 py-2 text-center font-semibold whitespace-nowrap">
            See integrations
          </a>

          <IntegrationsIcon1 className="lg:block hidden absolute  top-1/3 right-[15%]  h-16 w-16 -z-10" />
          <IntegrationsIcon4 className="absolute lg:top-3/4 lg:-right-[15%] top-[110%] right-[80%]  h-16 w-16 -z-10" />
          <IntegrationsIcon5 className="absolute lg:-top-[10%] lg:-right-[30%] top-[110%] right-0 h-16 w-16 -z-10" />
        </div>
      </div>
    </div>
  );
};

export default Integrations;
